module.exports = __webpack_public_path__ + "img/advisory_bj_02.30dd3acf.png";